var generateComponentTheme = function generateComponentTheme(_ref) {
  var colors = _ref.colors,
    borders = _ref.borders;
  return {
    userResponseShadowColor: colors.white,
    correctColor: colors.electric,
    incorrectColor: colors.crimson,
    unknownColor: colors.slate,
    wrapperBorderWidth: borders.widthLarge
  };
};
export default generateComponentTheme;